module.exports = __webpack_public_path__ + "fonts/HSESlab-Italic.0f174ff.otf";